module.exports = __webpack_public_path__ + "static/media/invlogo.4ba13b7e.jpeg";